import React, { PureComponent } from 'react';
import PickedMagazineContainer from '../components/pickedMagazine/PickedMagazineContainer';

export default class EditorsPicked extends PureComponent {
  render() {
    return (
      <div className="magazine-wrapper page-container">
        <PickedMagazineContainer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditorsPicked.js